import { ShoppingCartSummaryData } from '../../../app/data/model';
import { IEvent } from '../../../app/shared/EventAggregator';

export class ShoppingCartUpdatedEvent implements IEvent {
  constructor(public readonly shoppingCartSummary: ShoppingCartSummaryData) {}
}
